
import 'pages/purchases/purchases-list.tag'
import 'pages/purchases/purchases-edit.tag'
riot.tag2('purchases', '  <div class="column" if="{!notFound}">\n    <purchases-list if="{!edit}"></purchases-list>\n    <purchases-edit if="{edit}"></purchases-edit>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this,
    route = riot.route.create();

self.edit = false;

route('/purchases', function () {
    self.notFound = false;
    self.edit = false;
    self.update();
});

route('/purchases/new', function () {
    observable.trigger('purchase-new');
    self.notFound = false;
    self.edit = true;
    self.update();
});

route('/purchases/([0-9]+)', function (id) {
    observable.trigger('purchase-edit', id);
    self.notFound = false;
    self.edit = true;
    self.update();
});

route('/purchases..', function () {
    self.notFound = true;
    self.update();
    observable.trigger('not-found');
});

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/purchases/purchases.tag